import useConnectivity from 'hooks/useConnectivity';
import NoNetworkPage from './NoNetworkPage';

/**
 * Mounts the no-network page while the network is unreachable.
 *
 * One line in each portal root (AdminApp / PartnerApp) — inside the MUI theme
 * provider so the page takes that portal's colours, outside the auth gate so
 * the login screen is covered too. Deliberately NOT in the AppLayouts, which
 * only render behind ProtectedRoute. Fully unmounted between outages so the
 * Modal's focus and aria bookkeeping runs on every show/hide.
 *
 * Both this file and everything it imports must stay eager imports: every
 * route is code-split, and a chunk cannot be fetched while offline.
 */
export default function NoNetworkGuard() {
  const { offline, checking, retryFailed, retry } = useConnectivity();
  if (!offline) return null;
  return <NoNetworkPage onRetry={retry} checking={checking} retryFailed={retryFailed} />;
}
